<template>
	<li class="page-item" :class="{active:isActive}">
		<slot>
			<button class="page-link" href="#" @click.prevent="$emit('click-index', value)">{{value}}</button>
		</slot>		
	</li>
</template>

<script>
	export default {
		name: 'TablePaginationItem',
		props: ['value','isActive']
	}
</script>


// WEBPACK FOOTER //
// src/components/TablePaginationItem.vue